export default __webpack_public_path__ + "static/media/logo.d4405398.svg";